import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {ModuleRolePermissionList} from "../models/moduleRolePermissionList";
import {ModuleRolePermissionService} from "../services/moduleRolePermission.service";


@Injectable()
export class ModuleRolePermissionsResolve implements Resolve<ModuleRolePermissionList> {
    constructor(private moduleService: ModuleRolePermissionService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ModuleRolePermissionList> {
        return this.moduleService.getAll();
    }
}
